import React from "react";

function Footer() {
return (
<footer className="footer">
<p>© {new Date().getFullYear()} Biokare Dental Clinic. All rights reserved.</p>
</footer>
);
}

export default Footer;